import { Upload } from "lucide-react";
import { ALL_SAMPLE_PHOTOS } from "./fixtures";

/** Mock of the Upload screen: drop-zone + sample thumbnail grid. */
export function UploadPreview() {
  return (
    <div className="w-full h-full p-3 flex flex-col gap-2">
      <div className="rounded-xl border-2 border-dashed border-[var(--roava-blue)]/40 bg-[var(--roava-blue)]/5 py-3 flex flex-col items-center justify-center gap-1">
        <div className="size-8 rounded-full bg-[var(--roava-blue)]/15 grid place-items-center text-[var(--roava-blue)]">
          <Upload className="size-4" />
        </div>
        <p className="text-[11px] font-medium text-[var(--roava-text)]">Drop photos here</p>
        <p className="text-[10px] text-[var(--roava-text-muted)]">or tap to choose from your library</p>
      </div>
      <div className="grid grid-cols-3 gap-1.5 flex-1">
        {ALL_SAMPLE_PHOTOS.slice(0, 6).map((p) => (
          <div key={p.id} className="relative rounded-md overflow-hidden bg-[var(--roava-border)]">
            <img src={p.url} alt="" className="w-full h-full object-cover" loading="lazy" draggable={false} />
            <span className="absolute top-1 right-1 text-[9px] font-semibold text-white bg-black/50 rounded px-1 py-[1px]">
              {p.capturedAt}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
